import { ReactNode, useEffect, useState } from "react";

export function useDeferredMount() {
  const [isMount, setIsMount] = useState(false);

  useEffect(() => {
    setIsMount(true);
  }, []);

  return {
    isMount,
  };
}

export function DeferredMount({ children }: { children: ReactNode }) {
  const { isMount } = useDeferredMount();

  if (!isMount) {
    return null;
  }

  return children;
}
